export default __webpack_public_path__ + "static/media/teamTableSearch.dc925ce5.svg";